// Caption editor (Simple / Studio views, popups, player, settings panel, export)
const editor = {
  // Header & status
  'Saved': 'تم الحفظ',
  'Export': 'تصدير',
  'Simple View': 'العرض البسيط',
  'Simple': 'بسيط',
  'Studio View': 'عرض الاستوديو',
  'Studio': 'استوديو',
  'Undo (Ctrl+Z)': 'تراجع (Ctrl+Z)',
  'Undo': 'تراجع',
  'Redo (Ctrl+Shift+Z)': 'إعادة (Ctrl+Shift+Z)',
  'Redo': 'إعادة',
  'Original': 'الأصل',
  'New': 'جديد',
  'Close': 'إغلاق',
  'Got it': 'فهمت',
  'Upgrade': 'ترقية',
  'Verify': 'تأكيد',

  // Mobile read-only view
  'Foreign Words': 'الكلمات الأجنبية',
  'Tap to change style': 'اضغط لتغيير طريقة العرض',
  'عربي': 'عربي',
  'مترجم': 'مترجم',
  'Locked to Latin (code-switched) in Arabizi mode.': 'مثبتة على الحروف اللاتينية (كما هي) في وضع العربيزي.',
  'words': 'كلمة',
  'wpm': 'كلمة/دقيقة',
  'Read-only': 'للقراءة فقط',
  'No text to display': 'لا يوجد نص لعرضه',
  'Read-only mode · Open your computer to edit': 'وضع القراءة فقط · افتح المحرر على الكمبيوتر للتعديل',
  'Viewing 50% of transcript': 'تشاهد 50% من النص',
  'Verify to unlock': 'أكّد رقمك لفتح الباقي',
  'Verify your phone to unlock full content': 'أكّد رقم هاتفك لفتح النص كاملًا',
  'Review before exporting': 'راجع قبل التصدير',
  'We recommend editing your transcript on a computer first to ensure accuracy before exporting.':
    'ننصحك بمراجعة النص على الكمبيوتر أولًا للتأكد من دقته قبل التصدير.',

  // Export
  'Export transcript': 'تصدير النص',
  'Export for editor': 'تصدير لبرنامج مونتاج',
  'Downloads an SRT and shows steps to import it into that app.': 'يحمّل ملف SRT ويعرض خطوات استيراده في البرنامج.',
  'Export source': 'مصدر التصدير',
  'Original (Darija)': 'الأصل (الدارجة)',
  'Translated (English)': 'المترجم (الإنجليزية)',
  'Export format': 'صيغة التصدير',
  'Chunking for export': 'تقسيم المقاطع للتصدير',
  'By Words': 'حسب الكلمات',
  'By Characters': 'حسب الأحرف',
  'Tip: set to <b>1 word</b> for word‑level chunks.': 'نصيحة: اختر <b>كلمة واحدة</b> للحصول على مقطع لكل كلمة.',
  'Uppercase everything': 'كل النص بأحرف كبيرة',
  'Silence-aware chunks': 'التقسيم عند التوقف',
  'Punctuation-aware chunks': 'التقسيم عند علامات الترقيم',
  'Reorganize': 'إعادة التنظيم',
  'Download {format}': 'تنزيل {format}',
  'SRT export using Studio chunking. Or pick an editor below to download SRT and get import steps.':
    'تصدير SRT حسب تقسيم الاستوديو. أو اختر برنامج مونتاج أدناه لتنزيل SRT مع خطوات الاستيراد.',
  'Select SRT to customize chunking, or export for Premiere, DaVinci, CapCut, or Final Cut.':
    'اختر SRT لتخصيص التقسيم، أو صدّر إلى Premiere أو DaVinci أو CapCut أو Final Cut.',
  'SRT downloaded': 'تم تنزيل ملف SRT',
  'Import into {app}': 'الاستيراد إلى {app}',
  'Follow these steps to add your subtitles in {app}.': 'اتبع هذه الخطوات لإضافة الترجمة في {app}.',
  'Secure payment': 'دفع آمن',
  'Instant activation': 'تفعيل فوري',

  // NLE import guides
  'Your .srt file has been downloaded. Open your project in Adobe Premiere Pro.': 'تم تنزيل ملف ‎.srt. افتح مشروعك في Adobe Premiere Pro.',
  'Go to File → Import (or press Cmd+I / Ctrl+I) and select the downloaded .srt file.':
    'اذهب إلى File ← Import (أو اضغط Cmd+I / Ctrl+I) واختر ملف ‎.srt الذي نزّلته.',
  'In the Project panel, drag the imported captions onto your sequence timeline.': 'من لوحة Project، اسحب ملف الترجمة إلى الخط الزمني للتسلسل.',
  'When prompted for caption format, choose Subtitle (best for styling). Use Source Timecode to keep sync.':
    'عند السؤال عن صيغة الترجمة، اختر Subtitle (الأفضل للتنسيق)، واستخدم Source Timecode للحفاظ على التزامن.',
  'Captions appear on a C1 track above your video. Open Window → Essential Graphics (or Text) to style font, size, color, and position.':
    'تظهر الترجمة على مسار C1 فوق الفيديو. افتح Window ← Essential Graphics (أو Text) لتنسيق الخط والحجم واللون والموضع.',
  'Select all caption clips to apply the same style everywhere, then export with captions burned in or as a sidecar.':
    'حدّد كل مقاطع الترجمة لتطبيق نفس التنسيق عليها، ثم صدّر الفيديو مع الترجمة مدمجة أو كملف منفصل.',
  'Your .srt file has been downloaded. Open your project in DaVinci Resolve (Edit page).': 'تم تنزيل ملف ‎.srt. افتح مشروعك في DaVinci Resolve (صفحة Edit).',
  'Go to File → Import → Subtitle… and select the downloaded .srt file.': 'اذهب إلى File ← Import ← Subtitle… واختر ملف ‎.srt الذي نزّلته.',
  'Alternatively: right-click the timeline header → Add Subtitle Track, then drag the .srt from the Media Pool onto that track.':
    'أو: انقر بزر الفأرة الأيمن على رأس الخط الزمني ← Add Subtitle Track، ثم اسحب ملف ‎.srt من Media Pool إلى هذا المسار.',
  'Subtitles appear on a dedicated subtitle track above your video, timed to the SRT cues.': 'تظهر الترجمة على مسار خاص فوق الفيديو، متزامنة مع توقيتات ملف SRT.',
  'Select a subtitle and open the Inspector to adjust font, size, color, stroke, background, and position.':
    'حدّد سطر ترجمة وافتح Inspector لضبط الخط والحجم واللون والحدود والخلفية والموضع.',
  'When exporting, burn subtitles into the video or include them as a separate subtitle stream.':
    'عند التصدير، ادمج الترجمة في الفيديو أو أضفها كمسار ترجمة منفصل.',
  'Your .srt file has been downloaded. Open CapCut Desktop or CapCut Web.': 'تم تنزيل ملف ‎.srt. افتح CapCut على الكمبيوتر أو CapCut Web.',
  'Open your video project, then go to Text / Captions.': 'افتح مشروع الفيديو، ثم اذهب إلى Text / Captions.',
  'Choose Import Captions / Import Subtitles (or Captions → Add Captions) and select the .srt file. You can also drag it onto the timeline.':
    'اختر Import Captions / Import Subtitles (أو Captions ← Add Captions) وحدّد ملف ‎.srt. يمكنك أيضًا سحبه إلى الخط الزمني.',
  'CapCut creates editable text clips for each cue, synced to the timestamps.': 'ينشئ CapCut مقطع نص قابلًا للتعديل لكل سطر، متزامنًا مع التوقيتات.',
  'Select a caption and use the right panel to change font, size, color, position, and animations. Use “Apply to all” if available.':
    'حدّد سطر ترجمة واستخدم اللوحة الجانبية لتغيير الخط والحجم واللون والموضع والحركات. استخدم “Apply to all” إن كان متاحًا.',
  'Preview the timeline, then export your video with captions burned in.': 'راجع الخط الزمني، ثم صدّر الفيديو مع الترجمة مدمجة.',
  'Your .srt file has been downloaded. Open your project in Final Cut Pro.': 'تم تنزيل ملف ‎.srt. افتح مشروعك في Final Cut Pro.',
  'Go to File → Import → Captions… and select the downloaded .srt file.': 'اذهب إلى File ← Import ← Captions… واختر ملف ‎.srt الذي نزّلته.',
  'Captions appear in a dedicated caption lane above the primary storyline.': 'تظهر الترجمة في مسار خاص فوق الـ Primary Storyline.',
  'Double-click a caption (or use the caption editor) to fix text or tweak timing if needed.':
    'انقر نقرًا مزدوجًا على سطر ترجمة (أو استخدم محرر الترجمة) لتصحيح النص أو ضبط التوقيت عند الحاجة.',
  'Style captions from the inspector (font, size, color, position) so they match your project.':
    'نسّق الترجمة من Inspector (الخط، الحجم، اللون، الموضع) لتتناسب مع مشروعك.',
  'On export, include closed captions or burn subtitles into the video as required by your platform.':
    'عند التصدير، أضف الترجمة كملف منفصل أو ادمجها في الفيديو حسب متطلبات المنصة.',

  // Translation
  'Translate': 'ترجمة',
  'Translating...': 'جارٍ الترجمة...',
  'Translate Captions': 'ترجمة النص',
  'Translation in Progress': 'الترجمة قيد التنفيذ',
  'This usually takes 10-30 seconds...': 'يستغرق ذلك عادةً من 10 إلى 30 ثانية...',
  'Select Language': 'اختر اللغة',
  'American English': 'الإنجليزية الأمريكية',
  'Available': 'متاح',
  'Translation already requested. Please wait...': 'تم طلب الترجمة بالفعل. يُرجى الانتظار...',
  'Translation requested! This may take a few seconds...': 'تم طلب الترجمة! قد يستغرق ذلك بضع ثوانٍ...',
  'Failed to request translation': 'تعذّر طلب الترجمة',
  'No translation available. Request a translation first.': 'لا توجد ترجمة متاحة. اطلب الترجمة أولًا.',
  'Translation ready!': 'الترجمة جاهزة!',
  'Translation already requested': 'تم طلب الترجمة بالفعل',

  // Toasts & confirms
  'Saved successfully': 'تم الحفظ بنجاح',
  'Failed to save changes': 'تعذّر حفظ التغييرات',
  'Failed to load editor data': 'تعذّر تحميل بيانات المحرر',
  'Unable to export: missing job ID': 'تعذّر التصدير: معرّف المشروع غير موجود',
  'Unsupported export format': 'صيغة تصدير غير مدعومة',
  'Export failed. Please try again.': 'فشل التصدير. حاول مرة أخرى.',
  '↩ Undo': '↩ تراجع',
  'Nothing to undo': 'لا يوجد ما يمكن التراجع عنه',
  '↪ Redo': '↪ إعادة',
  'Nothing to redo': 'لا يوجد ما يمكن إعادته',
  'Words merged.': 'تم دمج الكلمات.',
  'Merge failed.': 'تعذّر الدمج.',
  'Replaced 1 match': 'تم استبدال نتيجة واحدة',
  'Replaced {count} matches': 'تم استبدال {count} نتيجة',
  'Replace all {count} matches?': 'استبدال كل النتائج ({count})؟',
  'Replace all matches': 'استبدال كل النتائج',
  'Replace all': 'استبدال الكل',
  'Leave the editor?': 'مغادرة المحرر؟',
  'Unsaved changes will be lost.': 'ستفقد التغييرات غير المحفوظة.',
  'Leave': 'مغادرة',
  'Stay': 'البقاء',
  'Phrases set to {mode}': 'تم عرض العبارات: {mode}',
  'transliterated (Arabic script)': 'بحروف عربية',
  'code switched': 'كما هي (حروف لاتينية)',
  'translated': 'مترجمة',
  'This phrase spans multiple lines. Merge them first to use alternatives.': 'هذه العبارة موزعة على أكثر من سطر. ادمج الأسطر أولًا لاستخدام البدائل.',
  'Skeleton not found': 'المقطع غير موجود',
  'Word not in skeleton': 'الكلمة ليست في هذا المقطع',
  'Word not found': 'الكلمة غير موجودة',
  'Word does not contain splittable spaces': 'لا تحتوي الكلمة على مسافة يمكن التقسيم عندها',
  'No previous word to merge with': 'لا توجد كلمة سابقة للدمج معها',
  'No next word to merge with': 'لا توجد كلمة تالية للدمج معها',
  'Adjacent word not found': 'الكلمة المجاورة غير موجودة',
  'Need at least 2 words': 'يجب اختيار كلمتين على الأقل',
  'Need at least 2 words to merge': 'يجب اختيار كلمتين على الأقل للدمج',
  'Words not in skeleton': 'الكلمات ليست في هذا المقطع',
  'Words not found': 'الكلمات غير موجودة',

  // Studio view
  'START': 'البداية',
  'END': 'النهاية',
  'Play segment': 'تشغيل المقطع',
  'Show': 'إظهار',
  'Hide': 'إخفاء',
  'Delete': 'حذف',
  'Previous': 'السابق',
  'Add your first caption': 'أضف أول سطر ترجمة',
  'Verify your number to continue': 'أكّد رقمك للمتابعة',
  'Verify your phone number to unlock the full transcript and continue editing.': 'أكّد رقم هاتفك لفتح النص كاملًا ومتابعة التعديل.',
  'Verify Now': 'تأكيد الآن',
  'Add segment': 'إضافة مقطع',
  'Add word before': 'إضافة كلمة قبلها',
  'Add word after': 'إضافة كلمة بعدها',
  'Remove word': 'حذف الكلمة',
  'Sync Out-of-Sync Words': 'مزامنة الكلمات غير المتزامنة',
  '({count} selected)': '(تم تحديد {count})',
  '<b>Shift+click</b> to select all words that are out of sync in a sequence': '<b>Shift+نقرة</b> لتحديد كل الكلمات غير المتزامنة المتتالية',
  'Adjust Timing': 'ضبط التوقيت',
  'Merge Words': 'دمج الكلمات',
  'Cancel selection': 'إلغاء التحديد',
  'Merge Selected Words': 'دمج الكلمات المحددة',
  'This will combine the selected words into a single word inside the same chunk.': 'سيتم دمج الكلمات المحددة في كلمة واحدة داخل نفس المقطع.',
  'Adjust Word Timing': 'ضبط توقيت الكلمات',
  '{count} words': {
    zero: '{count} كلمة',
    one: 'كلمة واحدة',
    two: 'كلمتان',
    few: '{count} كلمات',
    many: '{count} كلمة',
    other: '{count} كلمة',
  },
  '{count} chunks': {
    zero: '{count} مقطع',
    one: 'مقطع واحد',
    two: 'مقطعان',
    few: '{count} مقاطع',
    many: '{count} مقطعًا',
    other: '{count} مقطع',
  },
  '{count} phrases': {
    zero: '{count} عبارة',
    one: 'عبارة واحدة',
    two: 'عبارتان',
    few: '{count} عبارات',
    many: '{count} عبارة',
    other: '{count} عبارة',
  },
  'Reassign Word Timing': 'إعادة توزيع التوقيت',
  'Proportional Adjustment': 'ضبط تناسبي',
  'Selected:': 'المحدد:',
  'This will redistribute timing <b>proportionally</b> based on word length.': 'سيتم توزيع التوقيت <b>بشكل تناسبي</b> حسب طول كل كلمة.',
  '<b>Tip:</b> Use this when words have correct order but timing is uneven.': '<b>نصيحة:</b> استخدم هذا عندما يكون ترتيب الكلمات صحيحًا لكن التوقيت غير متوازن.',
  'Adjust Proportionally': 'ضبط تناسبي',
  'Audio Segments': 'المقاطع الصوتية',
  'Assigned Words': 'الكلمات المرتبطة',
  'Drop here': 'أفلت هنا',
  'No word': 'لا توجد كلمة',
  'Merge with next segment': 'دمج مع المقطع التالي',
  'Merge the audios into one': 'دمج المقطعين الصوتيين في مقطع واحد',
  'Drag words to reassign, or click for up/down options.': 'اسحب الكلمات لإعادة توزيعها، أو اضغط عليها لتحريكها لأعلى أو لأسفل.',
  'Apply Mapping': 'تطبيق التوزيع',
  'Move Up': 'تحريك لأعلى',
  'Move Down': 'تحريك لأسفل',

  // Simple view
  'Toggle Focus Mode': 'تفعيل/إيقاف وضع التركيز',
  'Focus': 'تركيز',
  'Editing translation structure not available': 'لا يمكن تعديل بنية الترجمة',

  // Word popup
  'End time cannot be before start time': 'لا يمكن أن يكون وقت النهاية قبل وقت البداية',
  'Overlaps with previous word "{word}" (ends at {time}s)': 'يتداخل مع الكلمة السابقة "{word}" (تنتهي عند {time} ث)',
  'Overlaps with next word "{word}" (starts at {time}s)': 'يتداخل مع الكلمة التالية "{word}" (تبدأ عند {time} ث)',
  'This will change the chunk start time from {from}s to {to}s': 'سيتغير وقت بداية المقطع من {from} ث إلى {to} ث',
  'This will change the chunk end time from {from}s to {to}s': 'سيتغير وقت نهاية المقطع من {from} ث إلى {to} ث',
  'Multiple Occurrences': 'تكرارات متعددة',
  'From': 'من',
  'To': 'إلى',
  'Found <b>{count} times</b>': 'وُجدت <b>{count} مرات</b>',
  'Replace All ({count})': 'استبدال الكل ({count})',
  'Only This': 'هذه فقط',
  'Play this word': 'تشغيل هذه الكلمة',
  'Edit word text': 'تعديل نص الكلمة',
  'Alternatives': 'البدائل',
  'Merge Lines Required': 'يجب دمج الأسطر',
  'Merge & Apply': 'دمج وتطبيق',
  'Attached Punctuation': 'علامة الترقيم المرفقة',
  'Latin': 'لاتيني',
  'Clear': 'مسح',
  'Save': 'حفظ',
  'Edit punctuation': 'تعديل علامة الترقيم',
  'Delete punctuation': 'حذف علامة الترقيم',
  'Start': 'البداية',
  'End': 'النهاية',
  'This word is at the chunk boundary': 'هذه الكلمة على حدود المقطع',
  'Confirm': 'تأكيد',
  'Apply Changes': 'تطبيق التغييرات',
  'Auto-adjust will shorten the previous word': 'الضبط التلقائي سيقصّر الكلمة السابقة',
  'Auto-adjust will delay the next word': 'الضبط التلقائي سيؤخر الكلمة التالية',
  'Auto-adjust': 'ضبط تلقائي',
  'OK': 'حسنًا',
  'Chunk': 'المقطع',
  'Merge with previous chunk': 'دمج مع المقطع السابق',
  'Merge with next chunk': 'دمج مع المقطع التالي',
  'Split into new chunk': 'فصل في مقطع جديد',
  'Word': 'الكلمة',
  'Split word': 'تقسيم الكلمة',
  'Merge previous': 'دمج مع السابقة',
  'Merge next': 'دمج مع التالية',
  'Remove speaker dash': 'إزالة شرطة المتحدث',
  'Restore speaker dash': 'استعادة شرطة المتحدث',
  'Add speaker dash': 'إضافة شرطة المتحدث',

  // Player
  'No words': 'لا توجد كلمات',
  'Your browser does not support the audio tag.': 'متصفحك لا يدعم تشغيل الصوت.',
  'Previous word': 'الكلمة السابقة',
  'Next word': 'الكلمة التالية',
  'Playback Speed': 'سرعة التشغيل',
  'Next: {word}': 'التالي: {word}',
  'Toggle time format': 'تغيير صيغة الوقت',

  // Settings panel
  'Behavior': 'السلوك',
  'Keep the current word in view while playing.': 'إبقاء الكلمة الحالية ظاهرة أثناء التشغيل.',
  'Editor & preview': 'المحرر والمعاينة',
  'Font Size': 'حجم الخط',
  'Balance readability and screen space.': 'وازن بين وضوح القراءة ومساحة الشاشة.',
  'Small': 'صغير',
  'Medium': 'متوسط',
  'Large': 'كبير',
  'Font': 'الخط',
  'Choose a font for your captions.': 'اختر خطًا للترجمة.',
  'Choose fonts for Arabic and Latin text.': 'اختر خطًا للنص العربي وآخر للنص اللاتيني.',
  'Arabic': 'العربية',
  'Classic': 'كلاسيكي',
  'Modern': 'عصري',
  'Geometric': 'هندسي',
  'Bold': 'عريض',
  'Clean': 'بسيط',
  'Serif': 'بزوائد',
  'Show Punctuation': 'إظهار علامات الترقيم',
  'Include ، ؟ ! . in captions': 'تضمين ، ؟ ! . في الترجمة',
  'Foreign Phrases': 'العبارات الأجنبية',
  'Pick a consistent style for non‑Arabic phrases.': 'اختر طريقة موحدة لعرض العبارات غير العربية.',
  'Foreign phrases shown in Arabic script': 'العبارات الأجنبية معروضة بالحروف العربية',
  'Foreign phrases shown in original Latin script': 'العبارات الأجنبية معروضة بحروفها اللاتينية الأصلية',
  'All foreign phrases translated': 'كل العبارات الأجنبية مترجمة',
  'Separate Latin/Arabic': 'فصل اللاتيني عن العربي',
  'Display and export all text in uppercase': 'عرض وتصدير كل النص بأحرف كبيرة',
  'Split chunks when silences appear': 'تقسيم المقاطع عند فترات الصمت',
  'Split chunks after punctuation': 'تقسيم المقاطع بعد علامات الترقيم',
  'Advanced · Speaker': 'متقدم · المتحدث',
  'No speaker data detected in the current captions. These settings will take effect once speaker information is available.':
    'لا توجد بيانات عن المتحدثين في هذه الترجمة. ستُطبَّق هذه الإعدادات عند توفر معلومات المتحدثين.',
  'Split by Speaker': 'التقسيم حسب المتحدث',
  'Start a new chunk when the speaker changes': 'بدء مقطع جديد عند تغيّر المتحدث',
  'Color by Speaker': 'تلوين حسب المتحدث',
  'Alternate between <dark>dark</dark> and <rose>rose</rose> text per speaker': 'التبديل بين اللون <dark>الداكن</dark> واللون <rose>الوردي</rose> لكل متحدث',
  'Dash on Speaker Change': 'شرطة عند تغيّر المتحدث',
  'Add a <dash>–</dash> before the first word of a new speaker': 'إضافة <dash>–</dash> قبل أول كلمة لمتحدث جديد',

  // Line settings popup
  'Invalid time values': 'قيم الوقت غير صحيحة',
  'Chunk Timing': 'توقيت المقطع',
  'sec': 'ث',
  'Apply Timing': 'تطبيق التوقيت',
  'Auto-adjust will shorten the previous chunk': 'الضبط التلقائي سيقصّر المقطع السابق',
  'Auto-adjust will delay the next chunk': 'الضبط التلقائي سيؤخر المقطع التالي',
  'Size': 'الحجم',
  'Position Y': 'الموضع العمودي',
  'Emphasize': 'إبراز',
  'Emphasize text': 'إبراز النص',
  'Reset': 'إعادة تعيين',
  'Reset All Lines': 'إعادة تعيين كل الأسطر',

  // Inline editor & search
  'Toggle Arabic Keyboard': 'إظهار/إخفاء لوحة المفاتيح العربية',
  'Keyboard': 'لوحة المفاتيح',
  'Show phrase alternatives': 'عرض بدائل العبارة',
  'Edit timing in Studio view': 'تعديل التوقيت في عرض الاستوديو',
  'Timing': 'التوقيت',
  'Search...': 'بحث...',
  '{current} of {total}': '{current} من {total}',
  'No matches': 'لا توجد نتائج',
  'Match Case': 'مطابقة حالة الأحرف',
  'Whole Word': 'الكلمة كاملة',
  'Use Regular Expression': 'استخدام تعبير نمطي (Regex)',
  'Previous Match (Shift+Enter)': 'النتيجة السابقة (Shift+Enter)',
  'Previous Match': 'النتيجة السابقة',
  'Next Match (Enter)': 'النتيجة التالية (Enter)',
  'Next Match': 'النتيجة التالية',
  'Toggle Replace': 'إظهار/إخفاء الاستبدال',
  'Close (Esc)': 'إغلاق (Esc)',
  'Replace with...': 'استبدال بـ...',
  'Replace Current': 'استبدال الحالية',
  'Replace': 'استبدال',
  'Replace All': 'استبدال الكل',
  'Enter: Next': 'Enter: التالي',
  'Shift+Enter: Previous': 'Shift+Enter: السابق',
  'Esc: Close': 'Esc: إغلاق',
  'Close and save': 'إغلاق وحفظ',

  // Tutorials
  'Tutorials': 'الدروس',
  'Take an Interactive Tour': 'جولة تفاعلية',
  'Learn the editor step by step': 'تعرّف على المحرر خطوة بخطوة',
  'Quick': 'سريعة',
  'More coming soon': 'المزيد قريبًا',
  'Getting Started': 'البداية',
  'Upload & begin': 'ارفع وابدأ',
  'Upload your project and start with ArabCap': 'ارفع مشروعك وابدأ مع ArabCap',
  'Edit Subtitles': 'تعديل الترجمة',
  'Adjust words': 'ضبط الكلمات',
  'Adjust and reorganize words in the editor': 'ضبط الكلمات وإعادة ترتيبها في المحرر',
  'Split & Chunks': 'التقسيم والمقاطع',
  'Manage display': 'التحكم في العرض',
  'Master word separation and display': 'إتقان فصل الكلمات وطريقة عرضها',
  'Convert Words': 'تحويل الكلمات',
  'Arabic ↔ Latin': 'عربي ↔ لاتيني',
  'Convert between Arabic, Latin, and translations': 'التحويل بين الحروف العربية واللاتينية والترجمة',
  'Add Subtitles to Capcut': 'إضافة الترجمة إلى CapCut',
  'Add Subtitles': 'إضافة الترجمة',
  'Add subtitles to your video in Capcut': 'أضف الترجمة إلى الفيديو في CapCut',
  'Adjust the delay of the subtitles': 'ضبط تأخير الترجمة',
  'Adjust delay ': 'ضبط التأخير',
};

export default editor;
